import { useTranslation } from 'react-i18next';
import { SearchBar } from 'redesign';
import { usePlanningParamsContext } from '../../../providers/planning-params-provider';

export const PlanningToolboxSearch = () => {
  const { t } = useTranslation('ogp-screen-specific');
  const { searchInput, setSearchInput } = usePlanningParamsContext();

  return (
    <SearchBar
      onChange={setSearchInput}
      initialValue={searchInput}
      placeholder={t('planning.toolbox.search.placeholder')}
    />
  );
};
